import {
  Box,
  Container,
  Button,
  Typography,
  IconButton,
  InputAdornment,
  useMediaQuery,
  Grid,
  Stack,
  Skeleton,
} from "@mui/material";

import { FORM_VALIDATIONS } from "../../constants/formValidation";

import { Controller, useForm } from "react-hook-form";

import { ROUTES } from "../../constants/routes";
import {
  confirmPasswordReset,
  getAuth,
  // verifyPasswordResetCode,
} from "firebase/auth";
import { useAppDispatch } from "../../store/appHooks";
import { handleSnackBar } from "../../slices/global";
import { useEffect, useState } from "react";
import MESSAGES from "../../constants/messages";
import { VisibilityOff, Visibility } from "@mui/icons-material";
import { postAPICallServer } from "../../utils/axios.util";
import { apiServerRoutes } from "../../constants/apiRoutes";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CustomTextField } from "components/mui-common/CustomTextField";
import { useTheme } from "@emotion/react";
import { AuthCardHeader, AuthCardSubHeader } from "./mui.styles";

const ResetPassword = () => {
  const { control, handleSubmit, getValues } = useForm({
    mode: "onChange",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [validUrl, setValidUrl] = useState(true);
  const [validatingUrl, setValidatingUrl] = useState(false);
  const [showPwd, setShowPwd] = useState({
    pwd: false,
    confirmPwd: false,
  });
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [query, setQuery] = useSearchParams();
  const code: string = query?.get("oobCode") ?? "";
  const auth = getAuth();
  const theme: any = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down("md"));
  useEffect(() => {
    setValidatingUrl(true);
    if (!code) {
      setValidUrl(false);
      setValidatingUrl(false);
      return;
    }

    (async () => {
      try {
        console.log(code);
        await postAPICallServer(apiServerRoutes.CHECK_RESET_TOKEN, {
          reset_token: code,
        });
        setValidUrl(true);
        setValidatingUrl(false);
      } catch {
        setValidUrl(false);
        setValidatingUrl(false);
      }
    })();
    // verifyPasswordResetCode(auth, code)
    //   .then(() => {
    //     setValidUrl(true)
    //     setValidatingUrl(false)
    //   })
    //   .catch((err) => {
    //     console.log(err.code)
    //     setValidUrl(err.code === 'auth/invalid-action-code' ? false : true)
    //     setValidatingUrl(false)
    //   })
  }, [code, auth, dispatch]);

  const resetPassword = (data: any) => {
    setIsSubmitting(true);
    confirmPasswordReset(auth, code, data.password)
      .then(async function () {
        await postAPICallServer(apiServerRoutes.SET_RESET_TOKEN, {
          reset_token: code,
        });
        dispatch(
          handleSnackBar({
            open: true,
            message: MESSAGES.PWd_RESET_SUCESS,
            severity: "success",
          })
        );
        setIsSubmitting(false);
        navigate(ROUTES.SIGNIN);
      })
      .catch((e) => {
        // Invalid code
        dispatch(
          handleSnackBar({
            open: true,
            message:
              e.code === "EXPIRED_OOB_CODE"
                ? e.message
                : "Something went wrong, please try again.",
            severity: "error",
          })
        );
      });
  };

  return (
    <Box
      sx={{
        backgroundColor: isMobileView ? "transparent" : "primary.main",
        minHeight: isMobileView ? "100%" : "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        p={3}
        sx={{
          maxWidth: isMobileView ? "100%" : "384px",
          background: "#fff",
          minWidth: "250px",
          borderRadius: "0.5rem",
          ...(isMobileView && { width: "100%", height: "100%" }),
        }}
      >
        {validatingUrl && (
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={2.5}
          >
            <Skeleton variant="rectangular" width="100%" height={40} />
            <Box width="100%">
              <Skeleton variant="text" width="100%" height={30} />
              <Skeleton variant="text" width="95%" height={30} />
              <Skeleton variant="text" width="50%" height={30} />
            </Box>
            <Skeleton variant="rectangular" width="100%" height={40} />
            <Skeleton variant="rectangular" width="100%" height={40} />
            <Skeleton variant="rectangular" width="100%" height={40} />
          </Stack>
        )}
        {!validUrl && !validatingUrl && (
          <Box
            display="flex"
            flexDirection="column"
            gap={2}
            justifyContent="center"
            alignItems="center"
          >
            <Typography>{MESSAGES.PWD_RESET_INVALIDCODE}</Typography>
            <Button
              size="large"
              onClick={() => navigate(ROUTES.FORGOT_PASSWORD)}
            >
              Reset Password
            </Button>
          </Box>
        )}

        {validUrl && !validatingUrl && (
          <form onSubmit={handleSubmit(resetPassword)}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <AuthCardHeader>Set Your New Password</AuthCardHeader>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12}>
                <AuthCardSubHeader>
                  Generate a strong and unique password for your account to
                  enhance security measures and protect from unauthorized
                  access.
                </AuthCardSubHeader>
              </Grid>
            </Grid>

            <Box
              display="flex"
              gap={2}
              justifyContent="center"
              alignItems="center"
              mb={3}
            >
              {/* <Image src="/images/lock.png" height={40} width={40} alt="" /> */}
              {/* <FpwdTitle>Set your New Password</FpwdTitle> */}
            </Box>
            <Box mt={4} display="flex" flexDirection="column" gap={3}>
              <Controller
                control={control}
                name="password"
                rules={{ ...FORM_VALIDATIONS.SIGNUP_PWD }}
                render={({ field: { onChange }, fieldState: { error } }) => (
                  <CustomTextField
                    variant="outlined"
                    placeholder="New password"
                    type={showPwd.pwd ? "text" : "password"}
                    fullWidth
                    onChange={onChange}
                    error={!!error}
                    helperText={error?.message ?? ""}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            edge="end"
                            onClick={() =>
                              setShowPwd({ ...showPwd, pwd: !showPwd.pwd })
                            }
                          >
                            {showPwd.pwd ? (
                              <VisibilityOff htmlColor="#9C9C9C" />
                            ) : (
                              <Visibility htmlColor="#9C9C9C" />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
              <Controller
                control={control}
                name="confirmPassword"
                rules={{
                  ...FORM_VALIDATIONS.SIGNUP_PWD,
                  validate: (value: string) =>
                    getValues().password === value ||
                    "Confirm password should be same as your Password",
                }}
                render={({ field: { onChange }, fieldState: { error } }) => (
                  <CustomTextField
                    variant="outlined"
                    placeholder="Confirm new password"
                    type={showPwd.confirmPwd ? "text" : "password"}
                    fullWidth
                    onChange={onChange}
                    error={!!error}
                    helperText={error?.message ?? ""}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            edge="end"
                            onClick={() =>
                              setShowPwd({
                                ...showPwd,
                                confirmPwd: !showPwd.confirmPwd,
                              })
                            }
                          >
                            {showPwd.confirmPwd ? (
                              <VisibilityOff htmlColor="#9C9C9C" />
                            ) : (
                              <Visibility htmlColor="#9C9C9C" />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
              {isMobileView && <br />}
              <Box display="flex" flexDirection="column" gap={2}>
                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  disabled={isSubmitting}
                  size="large"
                >
                  {!isMobileView ? "Submit" : "Reset Password"}
                </Button>
              </Box>
            </Box>
          </form>
        )}
      </Box>
    </Box>
  );
};

export default ResetPassword;
